import React from "react";
import {
  OPT_IN_TRANSACTION_STATUS_LABELS,
  OptInTransaction,
  OptInTransactionStatus,
} from "../../api/optInOffers";
import { formatCurrency } from "../../helpers/formatNumber";
import { formatCopenhagenDateTime } from "../../helpers/dateFilters";

const BADGE = "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium";

const STATUS_STYLES: Record<OptInTransactionStatus, string> = {
  Paid: "bg-green-100 text-green-800",
  Compensated: "bg-blue-100 text-blue-800",
  NotOptedIn: "bg-red-100 text-red-800",
  OtherFailure: "bg-gray-100 text-gray-800",
  ManualCredit: "bg-amber-100 text-amber-800",
};

interface OptInTransactionsTableProps {
  rows: OptInTransaction[];
  showPerson: boolean;
  onPersonClick?: (identityId: string) => void;
  emptyMessage?: string;
}

export const OptInTransactionsTable: React.FC<OptInTransactionsTableProps> = ({
  rows,
  showPerson,
  onPersonClick,
  emptyMessage = "No transactions.",
}) => {
  const columnCount = showPerson ? 7 : 6;
  return (
    <div className="overflow-x-auto">
      <table className="table-default">
        <thead>
          <tr>
            <th>Date</th>
            {showPerson && <th>Person</th>}
            <th>Source</th>
            <th>Amount</th>
            <th>Cashback</th>
            <th>Status</th>
            <th>Compensated on</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columnCount} className="text-center text-gray-500">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.rowId}>
                <td className="whitespace-nowrap">{formatCopenhagenDateTime(row.transactionAt)}</td>
                {showPerson && (
                  <td className="whitespace-nowrap">
                    {row.identityId && onPersonClick ? (
                      <button
                        type="button"
                        className="underline text-left"
                        onClick={() => onPersonClick(row.identityId as string)}
                      >
                        {row.name ?? row.email ?? "Unknown"}
                      </button>
                    ) : (
                      row.name ?? row.email ?? "Unknown"
                    )}
                    {row.isDeleted && (
                      <span className={`${BADGE} bg-gray-100 text-gray-800 ml-2`}>
                        Deleted account
                      </span>
                    )}
                  </td>
                )}
                <td className="whitespace-nowrap">{row.source}</td>
                <td className="whitespace-nowrap">{formatCurrency(row.amount)} kr</td>
                <td className="whitespace-nowrap">
                  {row.cashback === null ? "—" : `${formatCurrency(row.cashback)} kr`}
                </td>
                <td>
                  <span className={`${BADGE} ${STATUS_STYLES[row.status]}`}>
                    {OPT_IN_TRANSACTION_STATUS_LABELS[row.status]}
                  </span>
                </td>
                <td className="whitespace-nowrap">
                  {row.compensatedAt ? formatCopenhagenDateTime(row.compensatedAt) : "—"}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
